<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/Master'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <AnaLoading way="Client" :show="pageloading"></AnaLoading>
        <div v-if="!pageloading">
        <b-container v-if="pageview">
            <ScoreResultCard title="整體勝敗分析" :score="anaSubResult.score" :listdata="anaSubResult.explantion"></ScoreResultCard>
            <PlusClothCard :title="name+'加分穿搭'" :listdata="anaSubResult.cloth.explantion" :color="anaSubResult.cloth.color"></PlusClothCard>
            <PresonalCard v-for="(item , index) in anaSubResult.adversary" v-bind:key="index"  :title="anaSubResult.result[index].basic.name+'的個性分析'" :listdata="item.explantion"></PresonalCard>

        </b-container>
        <b-container v-else>
            <b-button class="mt-3" variant="primary" block to="/Master">返回{{ productName }}</b-button>
            <b-button class="mt-3" variant="primary" block to="/HistoryLog">返回歷史紀錄</b-button>
        </b-container>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import ScoreResultCard from '@/components/ScoreResultCard.vue'
import PresonalCard from '@/components/PresonalCard.vue'
import PlusClothCard from '@/components/PlusClothCard.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import {playSound} from '@/service/commuse'
export default {
  name: 'MasterResult',
  components: {Nav,PageHeader,ScoreResultCard,PresonalCard,PlusClothCard,AnaLoading},
  data () {
    return {
      productName:'高手過招',
      formData: {},
      pageloading:false,

    }
  },
  computed:{
    ...mapState(['profiledata','anaSubResult']),
    pageview:function () {return Object.keys(this.anaSubResult).length === 0 ? false: true;},
    name:function () {return this.profiledata !==null ? this.profiledata.first_name+this.profiledata.last_name : '';},

  },
  mounted(){
    this.loadingView()
  },
  methods: {

    loadingView(){
      setTimeout(()=>{
        if(this.pageview){
          playSound()
        }
        this.pageloading = false
      },2500)


    }

  }
}
</script>

<style scoped>

</style>
